import { render, staticRenderFns } from "./decorateGarbageClear.vue?vue&type=template&id=9635f976&scoped=true&"
import script from "./decorateGarbageClear.vue?vue&type=script&lang=js&"
export * from "./decorateGarbageClear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9635f976",
  null
  
)

export default component.exports